export default __webpack_public_path__ + "static/media/burger.644fa295.svg";